import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { LINE_SETTINGS } from 'src/constants/characters'
import { useAuthState } from 'src/providers/AuthProviders'

import { MainLayout } from 'src/components/layouts/MainLayout'
import MenuWrapper from 'src/components/menu/MenuWrapper'
import ToggleSwitch from 'src/components/common/ToggleSwitch'
import SubmenuHeader from 'src/components/menu/SubmenuHeader'

const AccountPage = ({ toggleGlobalSetting }) => {
  const { user } = useAuthState()

  const listLineSetting = useMemo(() => {
    return LINE_SETTINGS.map((item) => ({
      ...item,
      isNotification: user[item.key],
      isLineFollow: item.followKey ? user[item.followKey] : true
    }))
  }, [user])

  console.log('listLineSetting', listLineSetting)

  return (
    <>
      <MainLayout active="menu" classNameHeader={''}>
        <MenuWrapper className="flex flex-col" overflow={true}>
          <>
            <SubmenuHeader title={'通知設定'} />{' '}
            <div className="hidden-scroll overflow-y-auto h-[calc(100dvh-210px)] mt-2  flex flex-col relative gap-3 pt-3">
              <p className="absolute right-4 font-Inter font-semibold text-[0.625rem] text-candy-pink top-0">
                通知ON/OFF
              </p>
              {listLineSetting?.map((character) => {
                return (
                  <NotifcationSettingBar
                    name={character.name}
                    img={character.icon}
                    isLineFollow={character.isLineFollow}
                    lineUrl={character.link}
                    accept={character.isNotification}
                    setAccept={() => {
                      toggleGlobalSetting({
                        [character.key]: !character.isNotification
                      })
                    }}
                    key={character.name}
                  />
                )
              })}
            </div>
          </>
        </MenuWrapper>
      </MainLayout>
    </>
  )
}

AccountPage.propTypes = {
  toggleGlobalSetting: PropTypes.func.isRequired
}

export default AccountPage

const NotifcationSettingBar = ({ name, img, lineUrl, isLineFollow, accept, setAccept }) => {
  return (
    <div className="gap-4 flex items-center justify-between w-full px-4 text-xs bg-white rounded font-Inter whitespace-nowrap cursor-pointer">
      <img className="w-1/3 h-auto" src={img} alt={name} />
      {isLineFollow ? (
        <span className="flex-1 h-full bg-[#d7d7d7] p-1 drop-shadow-md rounded-md text-white text-ellipsis flex items-center justify-center">
          LINE友だち追加済
        </span>
      ) : (
        <a
          href={lineUrl}
          target="_blank"
          rel="noreferrer"
          className="flex-1 h-full bg-candy-pink p-1 drop-shadow-md rounded-md text-white text-ellipsis flex items-center justify-center"
        >
          LINE友だち追加
        </a>
      )}
      <ToggleSwitch checked={accept} onChange={setAccept} srLabel={name} />
    </div>
  )
}

NotifcationSettingBar.propTypes = {
  name: PropTypes.string.isRequired,
  img: PropTypes.any.isRequired,
  setAccept: PropTypes.func.isRequired,
  lineUrl: PropTypes.string.isRequired,
  isLineFollow: PropTypes.bool,
  accept: PropTypes.bool
}
